export default __webpack_public_path__ + "static/media/created-flags.3bbdadcd.svg";